"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWithActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const ModalWithActions_module_css_1 = __importDefault(require("./ModalWithActions.module.css"));
const web_popup_1 = require("@snapchat/web-popup");
/**
 * Typical Modal component with actions
 */
function ModalWithActions({ closeModal, headerEl, bodyEl, footerEl, bodyClassName, }) {
    return ((0, jsx_runtime_1.jsxs)(web_popup_1.Popup, { children: [(0, jsx_runtime_1.jsx)("div", { className: ModalWithActions_module_css_1.default.modalBackdrop, "data-testid": "modal-backdrop", onClick: closeModal }), (0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(ModalWithActions_module_css_1.default.modalBodyContainer, bodyClassName), "data-testid": "modal-body", children: [headerEl, bodyEl, footerEl] })] }));
}
exports.ModalWithActions = ModalWithActions;
//# sourceMappingURL=index.js.map